import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=35179ac0&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=35179ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35179ac0",
  null
  
)

export default component.exports